// extracted by mini-css-extract-plugin
export default {"positionByRange":"positionByRange-dMisw","hidden":"hidden-E9485"};